import styled, {css} from 'styled-components';

// - Many React form control component libraries often come with default styling
// - Here, we remove these defaults  colors to apply our custom styling.
export const formLibraryReset = css`
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: none;
    border: none;
    color: var(--default-text-color);
    font-weight: 400;
    outline: none !important;
    width: 100%;
    box-shadow: none;
`;

export const FormControl = styled.div`
    background: var(--form-box-background-color);
    border: 1px solid var(--form-box-border-color);

    border-radius: var(--radius-form-control);
    position: relative;

    width: 100%;
    height: var(--height-form-control);
    min-height: var(--height-form-control);
    line-height: var(--height-form-control);
    display: block;

    input {
        height: var(--height-form-control);
    }

    input,
    textarea,
    .form-select__control,
    .form-select__control--is-focused {
        ${formLibraryReset}
    }

    // ------------------- //
    // === Placeholder === //
    // ------------------- //

    .form-select__control .form-select__placeholder,
    input::placeholder {
        color: var(--label-text-color);
        opacity: 1;
    }

    // ------------- //
    // === Input === //
    // ------------- //

    &:has(input) {
        padding: 0 var(--padding-form-control);
    }

    // ---------------- //
    // === Textarea === //
    // ---------------- //

    &:has(textarea),
    &:has(textarea) textarea {
        height: unset;
        min-height: var(--textarea-height-form-control);
        display: block;
        width: 100%;
    }

    &:has(textarea) textarea {
        padding: var(--space-sm) var(--padding-form-control);
    }

    // -------------------- //
    // === Height setup === //
    // -------------------- //
    // - Many React form control component libraries often come with default styling,
    // - including height. Here, we remove these defaults to apply our custom styling.

    .form-select__control,
    .form-select__control *,
    .form-select__control--is-focused,
    .form-select__control--is-focused * {
        padding: 0;
        margin: 0;
        color: var(--default-text-color);
    }

    .form-select__control,
    .form-select__control--is-focused {
        height: var(--height-form-control);
        min-height: var(--height-form-control);
        line-height: var(--height-form-control);
        display: block;
    }

    // ----------------------- //
    // === File type input === //
    // ----------------------- //

    &:has(input[type='file']) {
        background: none !important;
        border: none !important;
        padding: 0;
        padding-bottom: var(--space-lg);

        input {
            height: unset !important;
            padding: 0;
        }

        [type='file'] {
            color: var(--default-text-color);
        }

        [type='file']::-webkit-file-upload-button {
            background: var(--primary);
            border: 1px solid var(--primary);
            color: var(--default-btn-text-color);

            border-radius: 40px;
            cursor: pointer;
            font-size: var(--text-size-small);
            outline: none;
            padding: 10px 25px;
            text-transform: uppercase;
            transition: all 1s ease;
        }

        [type='file']::-webkit-file-upload-button:hover {
            background: var(--primary-dark);
            border: 1px solid var(--primary-dark);
        }
    }

    // --------------------------------------------------------- //
    // === Extra feature from AsyncSelect and Select library === //
    // --------------------------------------------------------- //

    .form-select__indicators {
        position: absolute;
        top: 50%;
        right: 12px;
        z-index: 9;
        transform: translateY(-50%);

        svg {
            height: 14px;
            cursor: pointer;

            * {
                color: var(--danger) !important;
            }
        }
    }

    // -------------------------- //
    // === Textarea Condition === //
    // -------------------------- //
    ${({code}) => {
        if (code) {
            return css`
                textarea,
                input {
                    font-family: monospace !important;
                }
            `;
        } else {
            return css`
                textarea,
                input {
                    font-family: 'RobotoFont' !important;
                }
            `;
        }
    }}
`;
